import { render } from "./commercial-errorreport.vue?vue&type=template&id=1316f27b"
import script from "./commercial-errorreport.vue?vue&type=script&lang=js"
export * from "./commercial-errorreport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__